import { EVENT_NAMES } from "@scrile/api-provider/dist";
import { ErrorDTO } from "@scrile/api-provider/dist/lib/apiErrorHandler";
import emitter from "@/lib/emitter";

export function handleRequestError(
  e: ErrorDTO[] | Error,
  comparator: (e: ErrorDTO) => boolean,
  onSuccessCB?: (e: ErrorDTO) => void
) {
  if (Array.isArray(e)) {
    const errors = e.filter((e: ErrorDTO) => {
      if (comparator(e)) {
        onSuccessCB && onSuccessCB(e);
        return false;
      } else {
        emitter.emit(EVENT_NAMES.REQUEST_STATUS, e);
        return true;
      }
    });
    if (errors.length > 0) throw e;
  } else throw e;
}
